import { useState, useEffect } from 'react'

interface PublicAppInfo {
  app_name: string
  app_description?: string
  app_version?: string
  build_number?: string
}

export const usePublicAppInfo = () => {
  const [appInfo, setAppInfo] = useState<PublicAppInfo>({
    app_name: 'SynPris', // Valoare default
    app_description: 'Sistem de Informații Radiologice',
    app_version: 'N/A',
    build_number: 'N/A'
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchAppInfo = async () => {
      try {
        setLoading(true)
        setError(null)
        
        // Construim URL-ul dinamic bazat pe location
        const baseUrl = `${window.location.protocol}//${window.location.host}`
        const response = await fetch(`${baseUrl}/api/v1/public/app-info`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          // Nu includem credentials pentru endpoint-ul public
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        setAppInfo(data)
      } catch (err) {
        console.warn('Failed to fetch public app info, using defaults:', err)
        setError(err instanceof Error ? err.message : 'Unknown error')
        // Păstrăm valorile default în caz de eroare
      } finally {
        setLoading(false)
      }
    }

    fetchAppInfo()
  }, [])

  return { appInfo, loading, error }
}
